import React from 'react';

function Logo() {
  return (
    <div
      className="Logo"
      style={{
        fontFamily: 'quicksand',
        textAlign: 'left',
        color: 'black'
      }}
    >
      Shipyard Studios
    </div>
  );
}

export default Logo;
